<template>
    <div id="changePassWord">
        <div class="con">
            <img class="imgborder" src="../../assets/project/add-border.png" alt="">
            <div class="details">
                <div class="close" @click="close('ruleForm')">
                    <img src="../../assets/vehicleData/close.png" alt="">
                </div>
                <div class="title">
                    <img src="../../assets/project/project-left.png" alt="">
                    <span class="text">修改密码</span>
                    <img src="../../assets/project/project-right.png" alt="">
                </div>
                <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
                <div class="content">
                    <div class="content-item">
                        <div class="top">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" :validate-on-rule-change="false">
                                <el-form-item prop="old" >
                                    <div class="project-add-header">原始密码</div>
                                    <el-input placeholder="请输入新密码" v-model="ruleForm.old" :type="ruleForm.show.old?'text':'password'" auto-complete="new-password" style="width:100%;">
                                        <img
                                                :src="oldImage"
                                                slot="suffix"
                                                alt=""
                                                style="margin: 10px 0;"
                                                @click="oldClick()"
                                        >
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="new">
                                    <div class="project-add-header">新密码</div>
                                    <el-input placeholder="请输入新密码" :type="ruleForm.show.new?'text':'password'" v-model="ruleForm.new" auto-complete="new-password" style="width:100%;">
                                        <img
                                                :src="newImage"
                                                slot="suffix"
                                                alt=""
                                                style="margin: 10px 0;"
                                                @click="newClick()"
                                        >
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="check" >
                                    <div class="project-add-header">再次确认新密码</div>
                                    <el-input placeholder="请再次确认新密码" :type="ruleForm.show.check?'text':'password'" v-model="ruleForm.check" auto-complete="new-password" style="width:100%;">
                                        <img
                                                :src="checkImage"
                                                slot="suffix"
                                                alt=""
                                                style="margin: 10px 0;"
                                                @click="checkClick()"
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div  class="bottom">
                            <!-- <div class="project-button "  @click="resetForm('ruleForm')">
                                <div class="project-button-text">取消</div>
                            </div> -->
                            <div class="project-button project-button2" @click="submitForm('ruleForm')">
                                <div class="project-button-text">确定修改</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import AdministratorService from '../../../src/services/jaxrs/concrete/com.zny.eop.witAgriculture.api.AdministratorService'
    import eventBus from "../../eventBus";
export default {
    data(){
        const validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.new) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return{
            ruleForm: {
                old: '',
                new:'',
                check:'',
                show: {
                    old:false,
                    new:false,
                    check: false,
                },
            },
            oldImage:'',
            newImage:'',
            checkImage:'',
            rules: {
                old: [
                    { required: true, message: '请输入原始密码', trigger: 'blur' },
                ],
                new: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    {
                        min: 6,
                        max: 16,
                        message: "长度在 6 到 16 个字符",
                        trigger: "blur",
                    },
                ],
                check: [
                    { required: true, message: "请确认密码", trigger: "blur" },
                    {
                        min: 6,
                        max: 16,
                        message: "长度在 6 到 16 个字符",
                        trigger: "blur",
                    },
                    { validator: validatePass2, trigger: "blur", required: true },
                ],
            },
        }
    },
    mounted() {
        this.onload();
    },
    methods:{
        onload(){
            this.oldImage=require('../../assets/set/password-show.png')
            this.newImage=require('../../assets/set/password-show.png')
            this.checkImage=require('../../assets/set/password-show.png')
        },
        // 点击关闭
        close(formName){
            this.$refs[formName].resetFields();
            this.$store.state.systemList=''
            this.$store.state.list='centerBot'
        },
        // 取消
        resetForm(formName){
            this.$refs[formName].resetFields();
            this.$store.state.systemList=''
        },
        //原始密码点击显示隐藏
        oldClick(){
            this.ruleForm.show.old=!this.ruleForm.show.old
            if( this.ruleForm.show.old){
                this.oldImage=require('../../assets/set/password-hide.png')
            }else{
                this.oldImage=require('../../assets/set/password-show.png')
            }
        },
        newClick(){
            this.ruleForm.show.new=!this.ruleForm.show.new
            if( this.ruleForm.show.new){
                this.newImage=require('../../assets/set/password-hide.png')
            }else{
                this.newImage=require('../../assets/set/password-show.png')
            }
        },
        checkClick(){
            this.ruleForm.show.check=!this.ruleForm.show.check
            if( this.ruleForm.show.check){
                this.checkImage=require('../../assets/set/password-hide.png')
            }else{
                this.checkImage=require('../../assets/set/password-show.png')
            }
        },
        // 提交
        submitForm(formName){
            var that=this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    var data={
                        password:that.ruleForm.old,
                        newPassword:that.ruleForm.new,
                    }
                    AdministratorService.changePassword(data)
                    .then(res=>{
                        if(res){
                            that.$message({
                                type: 'success',
                                message: "提交成功!"
                            });
                            that.$store.state.systemList=''
                            that.$router.replace('/')
                            that.$refs[formName].resetFields();
                        }else{
                            that.$message.error("操作失败!");
                        }
                    })
                    // that.$refs[formName].resetFields();
                    // that.$store.state.systemList=''
                }
            })
        },
    },
}
</script>
<style lang="less">
@import '../../viewsStyle/system/changePassWord.less';

</style>